const BlockCn: React.FC = () => {
    return (
        <div>
            <h1>Sorry, the service is not currently available in your area.</h1>
        </div>
    );
};

export default BlockCn;